import React from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import ScrollAnimation from 'react-animate-on-scroll';

import mohawk_industries_logo from '../assets/images/mohawk_industries_logo.png';
import fishman_logo from '../assets/images/fishman_logo.png';
import armstrong_logo from '../assets/images/armstrong_logo.png';
import daroon_logo from '../assets/images/daroon_logo.png';

const useStyles = makeStyles(theme => ({
    container: {
        paddingTop: "100px",
        paddingBottom: "100px",
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.background.bg2,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    box: {
        "&:hover": {
            "& h3": {
                color: theme.palette.primary.main,
                //letterSpacing: 1,
            },
            "& img": {
                opacity: 0.5
            }
        },
        [theme.breakpoints.down("sm")]: {
            marginBottom: "10px"
        },
    },
}))


export default function Partners() {
    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <React.Fragment>
            <Grid container direction="column" className={classes.container} id="partners">

                <ScrollAnimation animateIn="slideInLeft" animateOnce={true}>
                    <Grid item>
                        <Typography variant="h2" gutterBottom>OUR PARTNERS</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="h1" paragraph>The Best Companies Cooperate With Us</Typography>
                    </Grid>
                </ScrollAnimation>

                <Grid item container direction="row" justify="space-between" style={{marginTop: "50px"}}>

                    <Grid item xs={6} md={3}>
                        <Grid item container direction="row" justify="center" className={classes.box} component={Link}
                              href="https://www.mohawkflooring.com/" target="blank">
                            <img src={mohawk_industries_logo} alt="mohawk industries"
                                 style={{
                                     width: "60%",
                                     transition: "0.5s",
                                     userSelect: "none",
                                     marginTop: "10px",
                                 }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Grid item container direction="row" justify="center" className={classes.box} component={Link}
                              href="https://daroonstudio.com/" target="blank">
                            <img src={daroon_logo} alt="daroonstudio"
                                 style={{
                                     width: "60%",
                                     transition: "0.5s",
                                     userSelect: "none",
                                     marginTop: "10px",
                                     cursor: "pointer"
                                 }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Grid item container direction="row" justify="center" className={classes.box} component={Link}
                              href="https://www.lfishman.com/" target="blank">
                            <img src={fishman_logo} alt="fishman"
                                 style={{
                                     width: "60%",
                                     transition: "0.5s",
                                     userSelect: "none",
                                     marginTop: "10px",
                                 }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Grid item container direction="row" justify="center" className={classes.box} component={Link}
                              href="https://www.armstrongflooring.com/" target="blank">
                            <img src={armstrong_logo} alt="armstrong " style={{
                                width: "60%",
                                transition: "0.5s",
                                userSelect: "none",
                                marginTop: "10px",
                            }}/>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </React.Fragment>

    );
}
